import * as yup from "yup";

const validationSchema = yup.object().shape({
  title: yup.string().trim().required("This field is required"),
  description: yup.string().trim().required("This field is required"),
});

export default validationSchema;
